import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Table, Form, Modal } from 'react-bootstrap';

import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileDownload } from '@fortawesome/free-solid-svg-icons';

import * as Common from '../Common';
import Dialog from '../Dialog';
import '../../mcss/common.css';

import PrintView from './PrintView';
import TransactionComment from './TransactionComment';

function BankFile(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);


    const [reqData, setReqData] = useState([]);
    const [docListData, setDocListData] = useState([]);
    const [remark, setRemark] = useState("");
    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);

    const [showUnlock, setShowUnlock] = useState(false);

    const [rightContryDiffer, setRightContryDiffer] = useState([]);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'BANKFILE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {

                    Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result1) {
                        let resp1 = JSON.parse(result1);
                        setReqData(resp1);
                        setDocListData(resp1.req_documentdetail);
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'CONTRYDIFFER'], function (result1) {
                        setRightContryDiffer(JSON.parse(result1));
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function btnBackClick() {
        props.callInProgress();
    }

    function btnAddComment() {
        var object1 = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiPaymentApprove, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setRemark("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }


    function btnDocumentView(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }

    function btnDownloadFile() {
        Common.callDownloadApiPost(Common.apiBankFile, "post", [sid, 'onebankfile', props.srno]);
    }

    function handleShowUnlock() {
        setShowUnlock(!showUnlock);
    }

    function btnUnlockCover() {
        var object1 = {
            srno: props.srno
        }
        Common.callApi(Common.apiCover, [sid, 'unlockcover', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);

            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function btnContryDiffer() {
        window.open("cd/" + props.srno, "_blank");
    }


    const getMimeType = (ext) => {
        switch (ext.toLowerCase()) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };
    const openDocument = (resp) => {
        setDocumentToView(resp.url_path);
        setDocumentTypeToView(getMimeType(resp.doc_ext));
        setDocumentDescToView(resp.docm_desc);
        setDocumentNameToView(resp.doc_aws_path);
        setShowDocument(true);
    };


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>In Progress/Bank File</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PrintView rhdata={reqData}></PrintView>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>Type</td>
                                        <td>Remark</td>
                                        <td>File Name</td>
                                         <td>Upload Timestamp</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docListData.map((res) =>
                                        <tr key={res.srno}>
                                            <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                            <td>{res.doc_remark}</td>
                                            <td>{res.doc_aws == 1 ? res.doc_aws_path.slice(10) : res.doc_filename}</td>
                                             <td>{res.doc_uploadedat}</td>
                                            <td>
                                                <div className="colorThemeBlue">
                                                 {
                                                    ( res.doc_aws != 1 && (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                    || res.doc_ext === "jpg" || res.doc_ext === "png") ) ? <>
                                                    <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </span>
                                                    </> : null
                                                    }

                                                    &nbsp;
                                                    &nbsp;
                                                    {(res.doc_aws == 1 &&
                                                        (
                                                            res.doc_ext === "pdf" ||
                                                            res.doc_ext === "jpeg" ||
                                                            res.doc_ext === "gif" ||
                                                            res.doc_ext === "jpg" ||
                                                            res.doc_ext === "png" ||
                                                            res.doc_ext === "webp"
                                                        )) && (
                                                            <span
                                                                onClick={() => Common.viewUploadedDocument(res.doc_aws_path, sid,openDocument)}
                                                                className="pointer colorThemeBlue"
                                                            >
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                    )}

                                                    &nbsp;&nbsp;
                                                    {res.doc_aws == 1 ? (
                                                        <span className="handCursor" onClick={() => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />

                                                        </span>
                                                    ) :
                                                        <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />
                                                        </span>

                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={6}>
                            <Form.Group >
                                <Form.Label>Comment</Form.Label>
                                <Form.Control type="text" placeholder="Comment" maxLength={100}
                                    onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setRemark)}
                                    value={remark} autoComplete="off" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group >
                                <Form.Label>&nbsp;</Form.Label><br></br>
                                <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                            </Form.Group>
                        </Col>
                    </Row>


                    <Row>
                        <Col>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                            <Button variant="outline-success" size="sm" onClick={(e) => btnDownloadFile()} >Bank File</Button><span>&nbsp;</span>
                            {
                                rightContryDiffer.query === "1" ?
                                    <>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnContryDiffer()} >Country Differ</Button><span>&nbsp;</span>
                                    </>
                                    : null
                            }

                            {
                                reqData.req_bankfilegenrated === "0" ? <>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <input type="checkbox"
                                        checked={showUnlock}
                                        onChange={handleShowUnlock}
                                    />
                                </>
                                    : null
                            }
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            {
                                showUnlock ?
                                    <Button variant="outline-danger" size="sm"
                                        onClick={(e) => btnUnlockCover()}>Unlock Cover</Button>
                                    : null
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <TransactionComment srno={props.srno} rc={refreshCounter}></TransactionComment>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                    {
                        /*
                        type="image/png" type="application/pdf"
                        width="100%" height="100%"
                        
                        <object data={documentToView} type={documentTypeToView} class="internal">
    
                        </object>
                        */
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
export default BankFile;